import BaseEntityDto from "src/app/common/dtos/BaseEntityDto";

/**
 * Titles DTO
 */
export default class QAUserGroupsDTO extends BaseEntityDto
{
    /**
     * QA User Group Name
     */
    name: string = "";

    /**
     * List of items
     */
    users_ref: Array<any> = [];
}